import Delete from '@/common/assets/icons/deleteIcon.svg?react';
import DeleteConfirmationModal from '@/common/components/imageGallery/components/Extensions/deleteConfigration/modal/DeleteConfirmationModal';
import { DeleteExtensionProps } from '@/common/components/imageGallery/types/imageCard.type';
import useModal from '@/common/hooks/useModal';
import { Box } from 'styled-system/jsx';

export const DeleteExtension = ({
  onDeletePhotoHandler,
}: DeleteExtensionProps) => {
  const { closeModal, open, openModal } = useModal();

  return (
    <>
      <Box
        onClick={() => {
          openModal();
        }}
        position="absolute"
        top="0.5rem"
        left="0.5rem"
      >
        <Delete />
      </Box>
      <DeleteConfirmationModal
        open={open}
        closeModal={closeModal}
        onDeletePhoto={() => onDeletePhotoHandler(closeModal)}
      />
    </>
  );
};
